export interface RewardDTO {
  source?: string;
  agent_id?: number;
  agent_name?: string;
  agent_portal_task_id?: number;
  agent_portal_revision_id?: number;
  claim_snapshot?: { revision_id?: number; source?: string; agent_id?: number; agent_portal_task_id?: number; reward_amount_minor?: number; };
  attempt_no?: number;

  id: number;
  user_id: number;
  user_nickname: string;
  assignment_id: number;
  task_title: string;
  amount_fen: number;
  amount_yuan: string;
  status: RewardStatus;
  created_at: string;
  settled_at?: string;
}

export interface RewardListResponseDTO {
  total: number;
  page: number;
  page_size: number;
  items: RewardDTO[];
}

export type RewardStatus = 'pending' | 'settled' | 'cancelled';
export type RewardRange = '' | '7d' | 'month';

export const REWARD_STATUS_LABELS: Record<RewardStatus, string> = {
  pending: '待结算',
  settled: '已结算',
  cancelled: '已取消',
};

export const REWARD_RANGE_LABELS: Record<RewardRange, string> = {
  '': '全部时间',
  '7d': '近7天',
  month: '本月',
};

export const ALL_REWARD_RANGES: RewardRange[] = ['', '7d', 'month'];
